import { useUTLSettingsContext } from "@dexteel/mesf-core";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import type { SxProps } from "@mui/material/styles";
import { get } from "lodash-es";
import { useMemo } from "react";
import {
	AREA_COLOR_PAINT,
	AREA_COLOR_PUNCH,
	AREA_COLOR_SAWS,
	AREA_COLOR_WELDS,
} from "../colors";

export const getButtonSx = (color: string): SxProps => ({
	textTransform: "none",
	px: 4,
	whiteSpace: "nowrap",
	height: 40,
	"&.Mui-selected, &.Mui-selected:hover": {
		backgroundColor: color,
		borderColor: color,
		color: "#fff",
		fontWeight: 500,
	},
});

type Props = {
	value: number | null;
	onChange: (areaId: number | null) => void;
};

export const AreaButtonGroup = ({ value, onChange }: Props) => {
	const { state } = useUTLSettingsContext();

	const areaButtons = useMemo(() => {
		const weldsId = Number(get(state, "settings.DefaultAreaId", 10));
		const sawsId = Number(get(state, "settings.SawsAreaId", 20));
		const paintId = Number(get(state, "settings.PaintAreaId", 40));
		const punchId = Number(get(state, "settings.PunchAreaId", 50));

		return [
			{ label: "Weld & Wax", areaId: weldsId, color: AREA_COLOR_WELDS },
			{ label: "Paint", areaId: paintId, color: AREA_COLOR_PAINT },
			{ label: "Punch", areaId: punchId, color: AREA_COLOR_PUNCH },
			{ label: "Saw", areaId: sawsId, color: AREA_COLOR_SAWS },
		];
	}, [state]);

	return (
		<ToggleButtonGroup
			exclusive
			value={value}
			onChange={(_, newValue) => {
				if (newValue === null) return;
				onChange(newValue);
			}}
			size="small"
		>
			{areaButtons.map((btn) => (
				<ToggleButton
					key={btn.areaId}
					value={btn.areaId}
					sx={getButtonSx(btn.color)}
				>
					{btn.label}
				</ToggleButton>
			))}
		</ToggleButtonGroup>
	);
};
